import React, { useEffect, useContext } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import { Header } from './Header';
import ProductSegmentList from './ProductSegmentList';
import { FiltersContextProvider } from './ProductSegmentFilters/FiltersContext';
import { FiltersButton } from './ProductSegmentFilters/FiltersButton';
import { ProductSegmentFilters } from './ProductSegmentFilters/ProductSegmentFilters';
import { SelectedOperationActions } from './SelectedOperationActions';
import { ProductAlertsContext } from './ProductAlertsProvider';
import { OperationType } from './types/SelectedOperation';
import styles from './ProductAlerts.module.less';

type PropsParams = {
  createSegment: string;
};
export const ProductAlerts = () => {
  const params = useParams<PropsParams>();
  const { user } = useAppStateContext();
  const { setSelectedOperation } = useContext(ProductAlertsContext);

  useEffect(() => {
    if (params.createSegment === 'new') {
      setSelectedOperation({ type: OperationType.CreateSegment });
    }
  }, []);

  if (user && !user.appPermissions['enable_product_alert']) {
    return <Redirect to="/" />;
  }

  return (
    <FiltersContextProvider>
      <Header>
        <FiltersButton />
      </Header>

      <div className={styles.content}>
        <ProductSegmentList />
        <ProductSegmentFilters />
      </div>

      <SelectedOperationActions />
    </FiltersContextProvider>
  );
};
